<!-- Copyright (c) ArubaCC - All Rights Reserved. -->
<mat-toolbar class="aup-header !bg-white justify-between">
  @if ((breakpoints$ | async)?.isHandsetLayout) {
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="isMenuExpanded = true; drawer.toggle()"
      >
      <mat-icon fontIcon="menu"></mat-icon>
    </button>
  }

  @if (!(breakpoints$ | async)?.isHandsetLayout) {
    <button
      type="button"
      aria-label="Toggle sidenav"
      mat-icon-button
      (click)="isMenuExpanded = !isMenuExpanded"
      >
      <mat-icon fontIcon="menu"></mat-icon>
    </button>
  }

  <a [routerLink]="['/']" class="mx-3" data-cy="app-logo">
    <img [src]="logoPath" [alt]="pageTitle" width="232" height="28" />
  </a>

  @if (!isMobile) {
    <span class="flex-1"></span>
  }

  @if (!isMobile) {
    <a mat-icon-button [routerLink]="['/', 'changelog']">
      <mat-icon svgIcon="news"></mat-icon>
    </a>
  }

  @if (!isMobile && shouldShowSettingsMenu) {
    <a
      mat-icon-button
      [routerLink]="['/', 'settings']"
      (click)="onCustomMenuOpen()"
      >
      <mat-icon svgIcon="settings"></mat-icon>
    </a>
  }

  @if (user$ | async) {
    <a mat-button [matMenuTriggerFor]="menu" class="ml-2">
      <mat-icon svgIcon="user" class="scale-[160%]"></mat-icon>
      @if (!isMobile) {
        <span class="capitalize ml-2">
          {{
          (user$ | async)?.owner?.businessName ||
          (user$ | async)?.owner?.name + ' ' + (user$ | async)?.owner?.surname
          }}
        </span>
      }
    </a>
  }
  <mat-menu #menu="matMenu">
    <a mat-menu-item [routerLink]="['/', 'user', 'profile']">
      <mat-icon svgIcon="user"></mat-icon>
      {{ 'USER_MENU.USER_PROFILE' | transloco }}
    </a>
    <a mat-menu-item [href]="appConfig.changePasswordUrl">
      <mat-icon svgIcon="security-lock"></mat-icon>
      {{ 'USER_MENU.CHANGE_PASSWORD' | transloco }}
    </a>
    <a mat-menu-item [href]="appConfig.manageAccountUrl">
      <mat-icon svgIcon="accessibility"></mat-icon>
      {{ 'USER_MENU.MANAGE_ACCOUNT' | transloco }}
    </a>
    <a mat-menu-item target="_blank" [href]="appConfig.assistanceUrl">
      <mat-icon svgIcon="assistance"></mat-icon>
      {{ 'USER_MENU.REQUEST_ASSISTANCE' | transloco }}
    </a>
    <a mat-menu-item target="_blank" [href]="appConfig.guidesUrl">
      <mat-icon svgIcon="guide"></mat-icon>
      {{ 'USER_MENU.GUIDE' | transloco }}
    </a>
    @if (shouldShowLanguageMenu) {
      <div
        mat-menu-item
        [matMenuTriggerFor]="languageMenu"
        class="cursor-pointer"
        >
        <mat-icon fontIcon="language"></mat-icon>
        {{ 'USER_MENU.LANGUAGE' | transloco }}
      </div>
    }
    <a mat-menu-item (click)="logout()">
      <mat-icon svgIcon="exit"></mat-icon>
      {{ 'USER_MENU.LOGOUT' | transloco }}
    </a>
  </mat-menu>

  <mat-menu #languageMenu="matMenu">
    @for (lang of availableLanguages; track lang) {
      <a mat-menu-item (click)="switchLanguage(lang)">
        @if (getCurrentLanguage() === lang) {
          <mat-icon fontIcon="check"></mat-icon>
        }
        <span [class.ml-6]="getCurrentLanguage() !== lang">{{ getLanguageDisplayName(lang) }}</span>
      </a>
    }
  </mat-menu>
</mat-toolbar>

<mat-sidenav-container class="aup-sidenav-container border-t-4 border-gray-300" autosize>
  <mat-sidenav
    #drawer
    class="aup-sidenav pt-4"
    [ngClass]="{ 'aup-sidenav-expanded': isMenuExpanded }"
    [attr.role]="(breakpoints$ | async)?.isHandsetLayout ? 'dialog' : 'navigation'"
    [mode]="(breakpoints$ | async)?.isHandsetLayout ? 'over' : 'side'"
    [opened]="(breakpoints$ | async)?.isHandsetLayout === false"
    >
    <div class="h-full flex flex-col justify-between !p-0 !mb-auto !px-4">
      @if (!customMenu || isMobile) {
        <aup-main-menu
          (closeDrawerIfMobile)="closeDrawerIfMobile()"
          [isMenuExpanded]="isMenuExpanded"
          [isMobile]="isMobile"
          class="aup-menu"
        ></aup-main-menu>
      }

      @if (customMenu === eCustomMenu.SETTINGS && !isMobile && shouldShowSettingsMenu) {
        <aup-settings-menu
          (closeDrawerIfMobile)="closeDrawerIfMobile()"
          [isMenuExpanded]="isMenuExpanded"
          [isMobile]="isMobile"
          class="aup-menu aup-submenu"
        ></aup-settings-menu>
      }

      @if (isMenuExpanded) {
        <div class="mb-3 flex flex-col align-center text-center px-3">
          <a class="mb-5 cursor-pointer text-sm" (click)="onSuggestionClick()">
            {{ 'SIDENAV.ANY_SUGGESTIONS' | transloco }}
          </a>
          <morningstar-button
            id="front-document-btn"
            [text]="'SIDENAV.COOKIEBOT.PERSONALIZE_COOKIE' | transloco"
            textAlignX="center"
            tag="a"
            href="javascript: Cookiebot.renew()"
            [isLink]="true"
          ></morningstar-button>
          <span class="text-sm">
            {{ 'SIDENAV.SOME_DOUBTS' | transloco }}
            <a class="uppercase" target="_blank" [href]="appConfig.guidesUrl">
              {{ 'SIDENAV.GUIDE' | transloco }}
            </a>
          </span>
        </div>
      }
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="p-2 md:p-5">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
<aup-job-progress></aup-job-progress>
